import styled from 'styled-components';
import { COLORS } from '../styleVars';
var LoadingBar = styled.div.withConfig({
  componentId: "sc-bgelyd-0"
})(["width:100%;height:0.5rem;background-color:", ";&::after{border-radius:0.5rem;content:'';position:absolute;top:0;left:0;width:inherit;height:inherit;background:linear-gradient(45deg,", " 0%,", " 60%);animation:progress 1.25s linear infinite;}@keyframes progress{0%{transform:translate3d(-100%,0,0);}100%{transform:translate3d(100%,0,0);}}"], COLORS.white, COLORS.fupaPrimary, COLORS.fupaSecondary);
export { LoadingBar };
//# sourceMappingURL=LoadingBar.js.map